import BudgetsKanban from "../../../components/budgetsKanban";

const BudgetsKanbanPage = (props: any) => {
  return <BudgetsKanban persona="TOWER" {...props} />;
};

export default BudgetsKanbanPage;
